import { render, staticRenderFns } from "./CreateTrigger.vue?vue&type=template&id=c4d86fce"
import script from "./CreateTrigger.vue?vue&type=script&lang=js"
export * from "./CreateTrigger.vue?vue&type=script&lang=js"
import style0 from "./CreateTrigger.vue?vue&type=style&index=0&id=c4d86fce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports